namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_entity, {

		Entity_head: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			height: '52px',
			alignItems: 'center',
			background: { color: $mol_theme.card },
			border: { bottom: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},

		Entity_name: {
			flex: { grow: 1, shrink: 1, basis: 'auto' },
			minWidth: 0,
			font: { weight: 600 },
		},

		Record_count: {
			alignItems: 'center',
			color: $mol_theme.shade,
			padding: { left: $mol_gap.block, right: $mol_gap.block },
			whiteSpace: 'nowrap',
		},

	} )

}
